module.exports = __webpack_public_path__ + "static/media/google_play@2x.91393315.png";